'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Viewport = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

var _isNumber = require('d2-utilizr/lib/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _isObject = require('d2-utilizr/lib/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isIE = require('d2-utilizr/lib/isIE');

var _isIE2 = _interopRequireDefault(_isIE);

var _arrayFrom = require('d2-utilizr/lib/arrayFrom');

var _arrayFrom2 = _interopRequireDefault(_arrayFrom);

var _arrayContains = require('d2-utilizr/lib/arrayContains');

var _arrayContains2 = _interopRequireDefault(_arrayContains);

var _arrayClean = require('d2-utilizr/lib/arrayClean');

var _arrayClean2 = _interopRequireDefault(_arrayClean);

var _arraySort = require('d2-utilizr/lib/arraySort');

var _arraySort2 = _interopRequireDefault(_arraySort);

var _clone = require('d2-utilizr/lib/clone');

var _clone2 = _interopRequireDefault(_clone);

var _FavoriteWindow = require('./FavoriteWindow.js');

var _InterpretationItem = require('./InterpretationItem.js');

var _PluginItem = require('./PluginItem.js');

var _FavoriteButton = require('./FavoriteButton.js');

var _EmbedButton = require('./EmbedButton.js');

var _EastRegion = require('./EastRegion.js');

var _LayoutButton = require('./LayoutButton.js');

var _OptionsButton = require('./OptionsButton.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Viewport = exports.Viewport = undefined;

exports.Viewport = Viewport = function Viewport(refs, cmp, config) {
    var uiManager = refs.uiManager,
        appManager = refs.appManager,
        i18nManager = refs.i18nManager,
        sessionStorageManager = refs.sessionStorageManager,
        instanceManager = refs.instanceManager,
        calendarManager = refs.calendarManager,
        dimensionConfig = refs.dimensionConfig,
        periodConfig = refs.periodConfig,
        uiConfig = refs.uiConfig,
        optionConfig = refs.optionConfig,
        api = refs.api,
        apiPath = appManager.getApiPath(),
        i18n = i18nManager.get(),
        dataObjectName = dimensionConfig.get('data').objectName,
        indicatorObjectName = dimensionConfig.get('indicator').objectName,
        dataElementObjectName = dimensionConfig.get('dataElement').objectName,
        operandObjectName = dimensionConfig.get('operand').objectName,
        dataSetObjectName = dimensionConfig.get('dataSet').objectName,
        eventDataItemObjectName = dimensionConfig.get('eventDataItem').objectName,
        programIndicatorObjectName = dimensionConfig.get('programIndicator').objectName,
        periodObjectName = dimensionConfig.get('period').objectName,
        organisationUnitObjectName = dimensionConfig.get('organisationUnit').objectName,
        treePanel = uiManager.get('treePanel'),
        layoutWindow = uiManager.get('layoutWindow'),
        optionsWindow = uiManager.get('optionsWindow'),
        favoriteWindow = uiManager.get('favoriteWindow'),
        displayProperty = appManager.getDisplayProperty(),
        displayPropertyUrl = appManager.getDisplayPropertyUrl(),
        dimensionPanelMap = {};

    cmp = cmp || {};

    var northRegion = cmp.northRegion;

    var eastRegion = cmp.eastRegion;

    var westRegionItems = cmp.westRegionItems;

    var chartTypeToolbar = cmp.chartTypeToolbar;

    var getChartType = function getChartType() {
        return chartTypeToolbar ? chartTypeToolbar.getChartType() : null;
    };

    var dataTypeToolbar = cmp.dataTypeToolbar;

    var getDataType = function getDataType() {
        return dataTypeToolbar ? dataTypeToolbar.getDataType() : null;
    };

    var statusBar = cmp.statusBar;

    var favoriteButton = uiManager.reg((0, _FavoriteButton.FavoriteButton)(refs), 'favoriteButton');

    var layoutButton = uiManager.reg((0, _LayoutButton.LayoutButton)(refs), 'layoutButton');

    var optionsButton = uiManager.reg((0, _OptionsButton.OptionsButton)(refs), 'optionsButton');

    var embedButton = uiManager.reg((0, _EmbedButton.EmbedButton)(refs), 'embedButton', 'onCurrent');

    var integrationButtons = cmp.integrationButtons;

    var DownloadButtonItems = cmp.DownloadButtonItems;

    var detailsButton = Ext.create('Ext.Button', {
        id: "toggleEastRegionButton",
        text: ' ',
        width: 26,
        padding: '3',
        iconCls: 'ns-button-icon-arrowlefttriple',
        iconState: 1,
        setIconState: function setIconState() {
            switch (this.iconState++ % 2) {
                case 1:
                    this.el.dom.style.visibility = "hidden";break;
                case 0:
                    this.el.dom.style.visibility = "visible";break;
            }
        },
        handler: function handler(b) {
            eastRegion.toggleCollapse();
            this.setIconState();
        }
    });

    // viewport

    //var accordionBody = Ext.create('Ext.panel.Panel', {
    //layout: 'accordion',
    //activeOnTop: true,
    //cls: 'ns-accordion',
    //bodyStyle: 'border:0 none; margin-bottom:2px',
    //height: 700,
    //dimensionPanels: null,
    //items: westRegionItems
    //});
    //uiManager.reg(accordionBody, 'accordionBody');

    //var accordion = Ext.create('Ext.panel.Panel', {
    //bodyStyle: 'border-style:none; border-top:1px solid #d6d6d6; padding:1px; padding-bottom:0; overflow-y:scroll;',
    //items: accordionBody,
    //setThisHeight: function(mx) {
    //var panelHeight = westRegionItems.length * 28,
    //height;

    //if (westRegion.hasScrollbar) {
    //height = panelHeight + mx;
    //this.setHeight(westRegion.getHeight() - 2);
    //accordionBody.setHeight(height - 2);
    //}
    //else {
    //height = westRegion.getHeight() - uiConfig.west_fill;
    //mx += panelHeight;
    //accordion.setHeight((height > mx ? mx : height) - 2);
    //accordionBody.setHeight((height > mx ? mx : height) - 4);
    //}
    //},
    //getExpandedPanel: function() {
    //for (var i = 0, panel; i < westRegionItems.length; i++) {
    //if (!westRegionItems[i].collapsed) {
    //return westRegionItems[i];
    //}
    //}

    //return null;
    //},
    //getFirstPanel: function() {
    //return accordionBody.items.items[0];
    //}
    //});
    //uiManager.reg(accordion, 'accordion');

    var westRegion = Ext.create('Ext.panel.Panel', {
        region: 'west',
        preventHeader: true,
        collapsible: true,
        collapseMode: 'mini',
        border: false,
        hasScrollbar: false,
        hasChartTypeToolbar: function hasChartTypeToolbar() {
            return !!chartTypeToolbar;
        },
        width: uiConfig.west_width + uiManager.getScrollbarSize().width,
        items: (0, _arrayClean2.default)([chartTypeToolbar, dataTypeToolbar, westRegionItems]),
        onScrollbar: function onScrollbar() {
            this.hasScrollbar = true;

            if (dataTypeToolbar) {
                dataTypeToolbar.setButtonWidth(uiManager.getScrollbarSize().width, true);
            }
        },
        setState: function setState(layout) {
            westRegionItems.setUiState(layout);
        }
    });
    uiManager.reg(westRegion, 'westRegion');

    var updateButton = Ext.create('Ext.button.Split', {
        text: '<b>' + i18n.update + '</b>&nbsp;',
        handler: function handler() {
            instanceManager.getReport();
        },
        arrowHandler: function arrowHandler(b) {
            b.menu = Ext.create('Ext.menu.Menu', {
                closeAction: 'destroy',
                shadow: false,
                showSeparator: false,
                items: [{
                    xtype: 'label',
                    text: i18n.download_data,
                    style: 'padding:7px 40px 5px 7px; font-weight:bold; color:#111; border:0 none'
                }, {
                    text: 'CSV',
                    iconCls: 'ns-menu-item-datasource',
                    handler: function handler() {
                        uiManager.openDataDump(null, 'csv');
                    }
                }],
                listeners: {
                    show: function show() {
                        uiManager.setAnchorPosition(b.menu, b);
                    },
                    hide: function hide() {
                        b.menu.destroy();
                    },
                    destroy: function destroy(m) {
                        b.menu = null;
                    }
                }
            });

            this.menu.show();
        }
    });
    uiManager.reg(updateButton, 'updateButton');

    var downloadButton = Ext.create('Ext.button.Button', {
        text: i18n.download,
        disabled: true,
        menu: {},
        handler: function handler(b) {
            b.menu = Ext.create('Ext.menu.Menu', {
                closeAction: 'destroy',
                shadow: false,
                showSeparator: false,
                items: function () {
                    var layout = instanceManager.getStateCurrent();

                    var jsonReq = layout.req();
                    var xmlReq = layout.req(null, 'xml');
                    var xlsReq = layout.req(null, 'xls');
                    var csvReq = layout.req(null, 'csv');
                    var jrxmlReq = layout.req(null, 'jrxml');
                    var sqlReq = layout.req('/analytics/debug/sql', 'sql');
                    var dataValueSetJsonReq = layout.req('/analytics/dataValueSet', 'json', null, null, true);
                    var dataValueSetXmlReq = layout.req('/analytics/dataValueSet', 'xml', null, null, true);

                    var items = [].concat(_toConsumableArray(DownloadButtonItems(refs)), [{
                        xtype: 'menuseparator'
                    }, {
                        xtype: 'label',
                        text: i18n.plain_data_sources,
                        style: 'padding:7px 5px 5px 7px; font-weight:bold'
                    }, {
                        text: 'JSON',
                        iconCls: 'ns-menu-item-datasource',
                        handler: function handler() {
                            uiManager.openPlainDataSource(jsonReq, null, true);
                        },
                        menu: [{
                            xtype: 'label',
                            text: i18n.metadata_id_scheme,
                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
                        }, {
                            text: 'ID',
                            iconCls: 'ns-menu-item-scheme',
                            handler: function handler() {
                                uiManager.openPlainDataSource(jsonReq, '&outputIdScheme=UID', true);
                            }
                        }, {
                            text: 'Code',
                            iconCls: 'ns-menu-item-scheme',
                            handler: function handler() {
                                uiManager.openPlainDataSource(jsonReq, '&outputIdScheme=CODE', true);
                            }
                        }, {
                            text: 'Name',
                            iconCls: 'ns-menu-item-scheme',
                            handler: function handler() {
                                uiManager.openPlainDataSource(jsonReq, '&outputIdScheme=NAME', true);
                            }
                        }]
                    }, {
                        text: 'XML',
                        iconCls: 'ns-menu-item-datasource',
                        handler: function handler() {
                            uiManager.openPlainDataSource(xmlReq, null, true);
                        },
                        menu: [{
                            xtype: 'label',
                            text: i18n.metadata_id_scheme,
                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
                        }, {
                            text: 'ID',
                            iconCls: 'ns-menu-item-scheme',
                            handler: function handler() {
                                uiManager.openPlainDataSource(xmlReq, '&outputIdScheme=UID', true);
                            }
                        }, {
                            text: 'Code',
                            iconCls: 'ns-menu-item-scheme',
                            handler: function handler() {
                                uiManager.openPlainDataSource(xmlReq, '&outputIdScheme=CODE', true);
                            }
                        }, {
                            text: 'Name',
                            iconCls: 'ns-menu-item-scheme',
                            handler: function handler() {
                                uiManager.openPlainDataSource(xmlReq, '&outputIdScheme=NAME', true);
                            }
                        }]
                    }, {
                        text: 'Microsoft Excel',
                        iconCls: 'ns-menu-item-datasource',
                        handler: function handler() {
                            uiManager.openPlainDataSource(xlsReq);
                        },
                        menu: [{
                            xtype: 'label',
                            text: i18n.metadata_id_scheme,
                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
                        }, {
                            text: 'ID',
                            iconCls: 'ns-menu-item-scheme',
                            handler: function handler() {
                                uiManager.openPlainDataSource(xlsReq, '&outputIdScheme=UID');
                            }
                        }, {
                            text: 'Code',
                            iconCls: 'ns-menu-item-scheme',
                            handler: function handler() {
                                uiManager.openPlainDataSource(xlsReq, '&outputIdScheme=CODE');
                            }
                        }, {
                            text: 'Name',
                            iconCls: 'ns-menu-item-scheme',
                            handler: function handler() {
                                uiManager.openPlainDataSource(xlsReq, '&outputIdScheme=NAME');
                            }
                        }]
                    }, {
                        text: 'CSV',
                        iconCls: 'ns-menu-item-datasource',
                        handler: function handler() {
                            uiManager.openPlainDataSource(csvReq);
                        },
                        menu: [{
                            xtype: 'label',
                            text: i18n.metadata_id_scheme,
                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
                        }, {
                            text: 'ID',
                            iconCls: 'ns-menu-item-scheme',
                            handler: function handler() {
                                uiManager.openPlainDataSource(csvReq, '&outputIdScheme=UID');
                            }
                        }, {
                            text: 'Code',
                            iconCls: 'ns-menu-item-scheme',
                            handler: function handler() {
                                uiManager.openPlainDataSource(csvReq, '&outputIdScheme=CODE');
                            }
                        }, {
                            text: 'Name',
                            iconCls: 'ns-menu-item-scheme',
                            handler: function handler() {
                                uiManager.openPlainDataSource(csvReq, '&outputIdScheme=NAME');
                            }
                        }]
                    }, {
                        text: i18n.advanced,
                        iconCls: 'ns-menu-item-advanced',
                        menu: [{
                            xtype: 'label',
                            text: i18n.data_value_set,
                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
                        }, {
                            text: 'JSON',
                            iconCls: 'ns-menu-item-datasource',
                            handler: function handler() {
                                uiManager.openPlainDataSource(dataValueSetJsonReq, null, true);
                            }
                        }, {
                            text: 'XML',
                            iconCls: 'ns-menu-item-datasource',
                            handler: function handler() {
                                uiManager.openPlainDataSource(dataValueSetXmlReq, null, true);
                            }
                        }, {
                            xtype: 'menuseparator'
                        }, {
                            xtype: 'label',
                            text: i18n.other_formats,
                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
                        }, {
                            text: 'JRXML',
                            iconCls: 'ns-menu-item-datasource',
                            handler: function handler() {
                                uiManager.openPlainDataSource(jrxmlReq, null, true);
                            }
                        }, {
                            text: i18n.raw_data + ' SQL',
                            iconCls: 'ns-menu-item-datasource',
                            handler: function handler() {
                                uiManager.openPlainDataSource(sqlReq, null, true);
                            }
                        }]
                    }]);

                    if (layout && !!layout.showHierarchy && layout.hasDimension('ou')) {
                        items.push({
                            xtype: 'label',
                            text: i18n.plain_data_sources + ' w/ hierarchy',
                            style: 'padding:7px 8px 5px 7px; font-weight:bold'
                        });

                        items.push({
                            text: 'CSV',
                            iconCls: 'ns-menu-item-datasource',
                            handler: function handler() {
                                layout.getResponse().clone().addOuHierarchyDimensions().printResponseCSV();
                            }
                        });
                    }

                    return items;
                }(),
                listeners: {
                    show: function show() {
                        uiManager.setAnchorPosition(b.menu, b);
                    },
                    hide: function hide() {
                        b.menu.destroy();
                    },
                    destroy: function destroy(m) {
                        b.menu = null;
                    }
                }
            });

            this.menu.show();
        }
    });
    uiManager.reg(downloadButton, 'downloadButton', 'onCurrent');

    var defaultButton = Ext.create('Ext.button.Button', {
        text: i18n.table,
        iconCls: 'ns-button-icon-table',
        toggleGroup: 'module',
        pressed: true
    });

    var centerRegion = Ext.create('Ext.panel.Panel', {
        region: 'center',
        bodyStyle: 'padding:1px',
        autoScroll: true,
        fullSize: true,
        cmp: [defaultButton],
        toggleCmp: function toggleCmp(show) {
            integrationButtons.forEach(function (cmp) {
                if (cmp && cmp.show && cmp.hide) {
                    if (show) {
                        cmp.show();
                    } else {
                        cmp.hide();
                    }
                }
            });
        },
        subscribed: [],
        subscribe: function subscribe(fn) {
            this.subscribed.push(fn);
        },
        renew: function renew(html) {
            this.update(html);
            this.subscribed.forEach(function (fn) {
                fn();
            });
        },
        setScroll: function setScroll(fn) {
            this.onScroll = fn;
        },
        removeScroll: function removeScroll() {
            this.onScroll = Function.prototype;
        },
        setOnResize: function setOnResize(fn) {
            this.onResize = fn;
        },
        removeOnResize: function removeOnResize() {
            this.onResize = Function.prototype;;
        },
        setSidePanelsUIState: function setSidePanelsUIState(favoriteId, interpretationId) {
            // If there is an interpretation loaded, collapse left panel and expand right panel
            if (interpretationId) {
                Ext.getCmp('toggleEastRegionButton').handler();
                Ext.getCmp('toggleWestRegionButton').handler();

                if (favoriteId && interpretationId == "new") {
                    eastRegion.openInterpretationWindow(favoriteId);
                }
            }
        },
        scrollTo: function scrollTo(x, y) {
            this.body.dom.scrollTo(x, y);
        },
        toggleEastRegion: function toggleEastRegion() {
            detailsButton.setIconState();
        },
        onScroll: Function.prototype,
        tbar: {
            defaults: {
                height: 26
            },
            items: [{
                id: "toggleWestRegionButton",
                text: ' ',
                width: 26,
                padding: '3',
                iconCls: 'ns-button-icon-arrowlefttriple',
                iconClsLeft: 'ns-button-icon-arrowlefttriple',
                iconClsRight: 'ns-button-icon-arrowrighttriple',
                iconState: 0,
                setIconState: function setIconState() {
                    this.setIconCls(this.iconState++ % 2 ? this.iconClsLeft : this.iconClsRight);
                },
                handler: function handler(b) {
                    westRegion.toggleCollapse();
                    this.setIconState();
                }
            }, ' ', updateButton, favoriteButton, {
                xtype: 'tbseparator',
                height: 24,
                style: 'border-color:transparent; border-right-color:#d1d1d1; margin-right:4px'
            }, layoutButton, optionsButton, {
                xtype: 'tbseparator',
                height: 24,
                style: 'border-color:transparent; border-right-color:#d1d1d1; margin-right:4px'
            }, downloadButton, embedButton, '->'].concat(_toConsumableArray(integrationButtons), [detailsButton])
        },
        bbar: statusBar,
        listeners: {
            render: function render(p) {
                p.body.on('scroll', function (e) {
                    this.onScroll(e);
                }, p);
            },
            resize: {
                fn: function fn(e) {
                    this.onResize(e);
                }
            }
        }
    });
    uiManager.reg(centerRegion, 'centerRegion');

    var setUiState = function setUiState(layout) {
        westRegion.setUiState(layout);
    };

    var getUiState = function getUiState() {
        var viewport = uiManager.get('viewport'),
            accordion = uiManager.get('accordion');

        var layoutWindow = viewport.getLayoutWindow(),
            optionsWindow = viewport.getOptionsWindow(),
            chartType = getChartType(),
            dataType = getDataType();

        var config = _extends({}, accordion.getUiState(layoutWindow, optionsWindow), optionsWindow.getOptions());

        if (chartType) {
            config.type = chartType;
        }

        if (dataType) {
            config.dataType = dataType;
        }

        return config;
    };

    var viewport = Ext.create('Ext.container.Viewport', _extends({
        layout: 'border',
        getUiState: getUiState,
        setUiState: setUiState,
        westRegion: westRegion,
        eastRegion: eastRegion,
        centerRegion: centerRegion,
        northRegion: northRegion,
        items: (0, _arrayClean2.default)([eastRegion, westRegion, centerRegion, northRegion]),
        getLayoutWindow: null,
        getOptionsWindow: null
    }, config, {
        listeners: {
            afterrender: function afterrender() {

                // west resize
                westRegion.on('resize', function () {
                    var panel = westRegionItems.getExpandedPanel();

                    if (panel) {
                        panel.onExpand();
                    }
                });

                // update cmp resize
                uiManager.getUpdateComponent().on('resize', function (cmp, width, height, eOpts) {
                    uiManager.resize({
                        cmp: cmp,
                        width: width,
                        height: height,
                        eOpts: eOpts
                    });
                });

                uiManager.onResize(function (cmp, width) {
                    if (width < 700 && cmp.fullSize) {
                        cmp.toggleCmp();
                        cmp.fullSize = false;
                    } else if (width >= 700 && !cmp.fullSize) {
                        cmp.toggleCmp(true);
                        cmp.fullSize = true;
                    }
                });

                // left gui
                var viewportHeight = uiManager.getHeight(),
                    numberOfTabs = appManager.dimensions.length + 3,
                    tabHeight = 28,
                    minPeriodHeight = 380;

                if (viewportHeight > numberOfTabs * tabHeight + minPeriodHeight) {
                    if (!_isIE2.default) {
                        accordion.setAutoScroll(false);
                        //westRegion.setWidth(uiConfig.west_width + 100);
                        accordion.doLayout();
                    }
                } else {
                    westRegion.onScrollbar();
                }

                // north
                if (northRegion) {
                    northRegion.setLogoWidth(centerRegion.getPosition()[0]);
                }

                // expand to make sure treepanel is rendered
                uiManager.get('organisationUnit').expand();
                uiManager.get('data').expand();

                // look for url params
                var id = appManager.getUrlParam('id'),
                    session = appManager.getUrlParam('s'),
                    interpretationId = appManager.getUrlParam('interpretationid'),
                    layout;

                if (id) {
                    if (interpretationId && interpretationId != "new") {
                        instanceManager.getById(id, function (layout) {
                            instanceManager.getInterpretationById(interpretationId, function (interpretation) {
                                uiManager.updateInterpretation(interpretation, layout);
                            });
                        });
                    } else {
                        instanceManager.getById(id);
                    }
                } else if ((0, _isString2.default)(session) && sessionStorageManager.get(session)) {
                    layout = new api.Layout(refs, sessionStorageManager.get(session)).val();

                    if (layout) {
                        instanceManager.getReport(layout, false, false, true);
                    }
                } else {
                    uiManager.update();
                }

                var initEl = document.getElementById('init');
                initEl.parentNode.removeChild(initEl);

                Ext.getBody().setStyle('background', '#fff');
                Ext.getBody().setStyle('opacity', 0);

                centerRegion.setSidePanelsUIState(id, interpretationId);

                // fade in
                Ext.defer(function () {
                    Ext.getBody().fadeIn({
                        duration: 600
                    });
                }, 300);
            }
        }
    }));

    return viewport;
};
//# sourceMappingURL=Viewport.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/Viewport.js
 ** module id = 169
 ** module chunks = 0 1
 **/